/** Responsable de etapa en flujo de orden (`id` y `name` persisten en BD; `key` es solo front). */
export interface ResponsibleOrder {
    id: number;
    name: string;
    /** Clave estable para código (no se persiste). */
    key: string;
}

/** Claves canónicas; deben coincidir con `key` en {@link RESPONSIBLES_ORDER_SOURCE}. */
export type ResponsibleOrderKey =
    | 'marketing'
    | 'compras'
    | 'coupa'
    | 'brand_factory'
    | 'proveedores'
    | 'calidad';

const RESPONSIBLES_ORDER_SOURCE: ReadonlyArray<ResponsibleOrder> = [
    { id: 1, name: 'Marketing', key: 'marketing' },
    { id: 2, name: 'Compras', key: 'compras' },
    { id: 3, name: 'Coupa', key: 'coupa' },
    { id: 4, name: 'Pico', key: 'brand_factory' },
    { id: 5, name: 'Proveedores', key: 'proveedores' },
    { id: 6, name: 'Calidad', key: 'calidad' }
];

function responsibleKeyToLabel(key: ResponsibleOrderKey): string {
    return key.indexOf('_') >= 0
        ? key
              .split('_')
              .map(part => part.toUpperCase())
              .join('_')
        : key.toUpperCase();
}

/** Referencias tipadas por `key` (generado desde {@link RESPONSIBLES_ORDER_SOURCE}). */
export const RESPONSIBLE_ORDER_KEY = Object.fromEntries(
    RESPONSIBLES_ORDER_SOURCE.map(({ key }) => [
        responsibleKeyToLabel(key as ResponsibleOrderKey),
        key
    ])
) as {
    readonly MARKETING: 'marketing';
    readonly COMPRAS: 'compras';
    readonly COUPA: 'coupa';
    readonly BRAND_FACTORY: 'brand_factory';
    readonly PROVEEDORES: 'proveedores';
    readonly CALIDAD: 'calidad';
};

/** Lista para UI / selects (misma data que la fuente; `id` y `name` sin cambios para BD). */
export const RESPONSIBLES_ORDER: ResponsibleOrder[] = RESPONSIBLES_ORDER_SOURCE.map(
    r => ({
        id: r.id,
        name: r.name,
        key: r.key
    })
);

/** `id` del responsable por {@link ResponsibleOrderKey} (tabla canónica). */
export function responsibleOrderIdByKey(key: ResponsibleOrderKey): number {
    const row = RESPONSIBLES_ORDER_SOURCE.find(r => r.key === key);
    if (!row) {
        throw new Error(`Responsable key no definida: ${String(key)}`);
    }
    return row.id;
}
